// Primary keys are AUTO_INCREMENT integers, so the API rejects a string id in a
// JSON body. A <select> always yields a string, so coerce at the boundary:
// keep form state as the string the control gives us, and convert with toId()
// when building a request payload. 0 means "none".
export const toId = (v) => {
  if (v === '' || v == null) return 0;
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
};

// sameId compares an id from state (string) with one from the API (number).
export const sameId = (a, b) => String(a ?? '') === String(b ?? '');
